module.exports = __webpack_public_path__ + "static/media/avatar-default.dc2fb7a9.svg";